import { createContext } from 'react'

import { createRouterStore } from '../store/createStore'

export const RouterStoreContext = createContext<
  ReturnType<typeof createRouterStore> | undefined
>(undefined)

export const RouterStoreProvier = RouterStoreContext.Provider
